import { jsxs as g, jsx as m } from "react/jsx-runtime";
import { useFormikContext as X } from "formik";
import { a as Y } from "../../../index-BPXwPXbk.mjs";
import { get as Z, isEmpty as H } from "lodash-es";
import { useRef as y, useState as W, useCallback as u, useMemo as N } from "react";
import { S as ee } from "../../../errors-YTprc4A2.mjs";
import { d as te } from "../../../helpers-CNa1KUVl.mjs";
import { AutoComplete as se } from "../../AutoComplete/AutoComplete.js";
import I from "../../Text/index.js";
import { isManualAddress as re, initialSingleAddressTouched as A, initialSingleAddressValues as ae } from "../helpers.js";
import ne from "./Details.js";
import { Wrapper as ue, DetailsWrapper as oe, BackToManualAddressLinkWrapper as le, Label as ce, ManualAddressLinkWrapper as ie } from "./styled.js";
const Ae = ({
  fieldName: e,
  label: S,
  notFoundAddress: L = () => "Can't find a matching address? Enter manually.",
  displayPOBox: V = !1,
  country: d = "AUS",
  isClearable: R = !0,
  loadOptions: T,
  loadAddressFullDetailsHandler: w,
  fullFormProps: U,
  allowManualAddressEntry: v = !0,
  persistLabelManualEntry: j,
  includeLga: M,
  debounceOptions: D = { enabled: !1 },
  ...E
}) => {
  const f = y([]), h = y(), O = y(0), { values: F, setFieldValue: s, setFieldTouched: o } = X(), n = Z(F, e);
  if (!n)
    throw new ee(
      `invalid fieldName "${e}" was provided to the <Single /> address component`
    );
  const [b, $] = W(n.summaryData.label), [x, B] = W(re(n)), l = y(n.summaryData), r = u(() => {
    const t = ae;
    s(`${e}.summaryData`, t.summaryData, !1), s(`${e}.fullDetails`, t.fullDetails, !0), l.current = t.summaryData, $("");
  }, [e, s]), k = u(
    (t) => {
      t && t.preventDefault(), r(), o(e, A(!1), !1), B(!0);
    },
    [e, o, r]
  ), K = u(
    (t) => {
      t.preventDefault(), r(), o(e, A(!1), !1), $(n.summaryData.label), B(!1);
    },
    [e, r, o, n.summaryData.label]
  ), _ = u(
    (t, a) => {
      if (O.current === 9) {
        const c = {
          label: b,
          value: ""
        };
        s(`${e}.summaryData`, c, !0);
      } else a.action === "clear" ? r() : f.current.length === 0 ? v ? k() : r() : (async (i) => {
        if (!i) {
          r();
          return;
        }
        const p = await w(
          i.value,
          d,
          i
        ), Q = {
          id: p.id,
          fullAddress: `${i.label}`,
          postCode: p.postCode,
          state: p.stateOrTerritory,
          suburb: p.suburbOrPlaceOrLocality,
          ...M ? { lga: p.lga } : {}
        };
        l.current = i, o(e, A(!0), !1), s(`${e}.summaryData`, i, !0), s(`${e}.fullDetails`, Q, !1);
      })(t);
    },
    [
      r,
      e,
      o,
      s,
      b,
      w,
      k,
      d,
      v,
      M
    ]
  ), C = u(
    async (t) => {
      const a = `${Y.searchUri}${V ? "?" : "?type=physical&"}country=${d}&search=${encodeURIComponent(t)}`, c = await T(a);
      return f.current = c, H(f.current) ? [{ label: L(t), value: "not-found" }] : f.current;
    },
    [d, V, T, L]
  ), q = N(
    () => D.enabled ? te(C, D.timeout) : C,
    [C, D]
  ), z = u(
    (t = "", { action: a }) => {
      if (a === "menu-close" && h.current === "input-blur" && !n.summaryData.value ? s(`${e}.summaryData`, l.current, !0) : a === "menu-close" && h.current, h.current = a, a === "input-change") {
        const c = {
          label: "",
          value: ""
        };
        l.current = c;
      }
      a !== "input-blur" && a !== "menu-close" ? $(t) : l.current.value && !n.summaryData.value && s(`${e}.summaryData`, l.current, !0);
    },
    [e, s, n.summaryData.value]
  ), G = u((t) => {
    O.current = t.keyCode;
  }, []), J = u(() => {
    const t = {
      label: "",
      value: ""
    };
    s(`${e}.summaryData`, t, !1);
  }, [e, s]), P = u(
    (t) => {
      t && t.preventDefault(), r();
    },
    [r]
  );
  return /* @__PURE__ */ g(ue, { children: [
    x ? /* @__PURE__ */ g(oe, { children: [
      /* @__PURE__ */ g(le, { children: [
        j && /* @__PURE__ */ m(ce, { children: S }),
        /* @__PURE__ */ m(
          I.Link,
          {
            target: "_self",
            value: "Back to address search",
            showBackChevron: !0,
            onClick: K,
            "data-testid": `${e}-BackToAddressSearchLink`
          }
        )
      ] }),
      /* @__PURE__ */ m(ne, { fieldName: e, ...U })
    ] }) : /* @__PURE__ */ m(
      se,
      {
        name: `${e}.summaryData`,
        label: S,
        loadOptions: q,
        inputValue: b,
        onFocus: J,
        onKeyDown: G,
        onClear: P,
        onInputChange: z,
        onChange: _,
        isClearable: R,
        ...E
      }
    ),
    v && !x && /* @__PURE__ */ m(ie, { children: /* @__PURE__ */ m(
      I.Link,
      {
        target: "_self",
        value: "Enter address manually",
        onClick: k,
        "data-testid": `${e}-ManualAddressLink`
      }
    ) })
  ] });
};
export {
  Ae as Single,
  Ae as default
};
